import { cn } from '@dashboard/ui'
import { ChangeEvent, InputHTMLAttributes, forwardRef } from 'react'

export interface RangeSliderProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  min?: number
  max?: number
  value: number
  width?: number
  onChange: (val: number) => void
}

const inputClasses = cn(
  'absolute h-2 w-full cursor-pointer appearance-none rounded-lg bg-transparent dark:bg-gray-700',
  '[&::-webkit-slider-thumb]:w-5',
  '[&::-webkit-slider-thumb]:h-5',
  '[&::-webkit-slider-thumb]:-mt-0.5',
  '[&::-webkit-slider-thumb]:appearance-none',
  '[&::-webkit-slider-thumb]:bg-white',
  '[&::-webkit-slider-thumb]:shadow-[0_0_0_2px_rgba(37,99,235,1)]',
  '[&::-webkit-slider-thumb]:rounded-full',
  '[&::-webkit-slider-thumb]:transition-all',
  '[&::-webkit-slider-thumb]:duration-150',
  '[&::-webkit-slider-thumb]:ease-in-out',
)

export const RangeSlider = forwardRef<HTMLInputElement, RangeSliderProps>(
  ({ value, min = 0, max = 100, onChange, width, ...rest }, ref) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      if (!onChange) {
        return
      }

      if (e && e.target) {
        const { value } = e.target
        onChange(parseInt(value))
      }
    }

    return (
      <div className="relative flex h-2 items-center py-4" style={{ width: width ? `${width}px` : '100%' }}>
        <div className="absolute h-2 w-full rounded bg-gray-300" />
        <div className="absolute h-2 rounded bg-yellow-400" style={{ width: value + '%' }} />
        <input
          className={cn(inputClasses, rest.className)}
          onChange={handleChange}
          {...rest}
          min={min}
          max={max}
          value={value}
          ref={ref}
          type="range"
        />
      </div>
    )
  },
)
